import { createTheme, CssBaseline, ThemeProvider } from "@mui/material";
import React from "react";

const MuiThemeProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const theme = createTheme({
    spacing: 4,
    palette: {
      mode: 'light',
      background: {
        default: '#FFFFFF',
        paper: 'rgba(255, 255, 255, 0.95)',
      },
      text: {
        primary: '#1A1A2E',
        secondary: '#4A4A5A',
      },
      primary: {
        main: '#F9A825',
        light: '#FFCA28',
        dark: '#F57F17',
        contrastText: '#1A1A2E',
      },
      secondary: {
        main: '#7C4DFF',
        light: '#B47CFF',
        dark: '#651FFF',
        contrastText: '#FFFFFF',
      },
      success: {
        main: '#4CAF50',
      },
    },
    typography: {
      fontFamily: '"Inter", "Noto Sans JP", "Helvetica", "Arial", sans-serif',
      h1: {
        fontSize: '3rem',
        fontWeight: 700,
        letterSpacing: '-0.02em',
        lineHeight: 1.2,
      },
      h2: {
        fontSize: '2.5rem',
        fontWeight: 700,
        letterSpacing: '-0.01em',
        lineHeight: 1.3,
      },
      h3: {
        fontSize: '2rem',
        fontWeight: 600,
        letterSpacing: '-0.01em',
        lineHeight: 1.4,
      },
      h4: {
        fontSize: '1.5rem',
        fontWeight: 600,
        lineHeight: 1.4,
      },
      h5: {
        fontSize: '1.25rem',
        fontWeight: 600,
        lineHeight: 1.5,
      },
      h6: {
        fontSize: '1rem',
        fontWeight: 600,
        lineHeight: 1.5,
      },
      body1: {
        fontSize: '1rem',
        lineHeight: 1.7,
      },
      body2: {
        fontSize: '0.875rem',
        lineHeight: 1.7,
      },
    },
    shape: {
      borderRadius: 12,
    },
    components: {
      MuiCssBaseline: {
        styleOverrides: {
          body: {
            backgroundColor: '#FFFFFF',
            backgroundImage: 'none',
            minHeight: '100vh',
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 16,
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
            '&:hover': {
              transform: 'translateY(-8px)',
              boxShadow: '0 12px 40px rgba(0, 0, 0, 0.15)',
            },
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: 8,
            textTransform: 'none',
            fontWeight: 600,
          },
        },
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
};

export default MuiThemeProvider;
